import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "VIRAL Logo",
  class: "px-tab-bar-logo",
  height: "24",
  src: "/img/logos/abaca-logo--white.svg"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "px-tab-bar-menu__wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PxMenu = _resolveComponent("PxMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'px-tab-bar--small': _ctx.isSmall }, "px-tab-bar"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'px-tab-bar__navigation': _ctx.items && _ctx.items.length > 0 }, "px-tab-bar__container"])
    }, [
      _createVNode(_component_RouterLink, {
        to: { name: 'home' },
        class: "px-tab-bar-logo__wrapper"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.items && _ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_PxMenu, {
              modelValue: _ctx.innerValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
              items: _ctx.items,
              "use-router": false,
              class: "px-tab-bar-menu",
              mode: "even"
            }, null, 8, ["modelValue", "items"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}